/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RecipientResolutionCandidate
 */
export interface RecipientResolutionCandidate {
    /**
     * 
     * @type {string}
     * @memberof RecipientResolutionCandidate
     */
    provider_id: string;
    /**
     * 
     * @type {string}
     * @memberof RecipientResolutionCandidate
     */
    facility_id: string;
    /**
     * 
     * @type {string}
     * @memberof RecipientResolutionCandidate
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof RecipientResolutionCandidate
     */
    city?: string;
    /**
     * 
     * @type {string}
     * @memberof RecipientResolutionCandidate
     */
    state?: string;
    /**
     * 
     * @type {string}
     * @memberof RecipientResolutionCandidate
     */
    provider_type?: string;
}

/**
 * Check if a given object implements the RecipientResolutionCandidate interface.
 */
export function instanceOfRecipientResolutionCandidate(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "provider_id" in value;
    isInstance = isInstance && "facility_id" in value;
    isInstance = isInstance && "name" in value;

    return isInstance;
}

export function RecipientResolutionCandidateFromJSON(json: any): RecipientResolutionCandidate {
    return RecipientResolutionCandidateFromJSONTyped(json, false);
}

export function RecipientResolutionCandidateFromJSONTyped(json: any, ignoreDiscriminator: boolean): RecipientResolutionCandidate {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'provider_id': json['provider_id'],
        'facility_id': json['facility_id'],
        'name': json['name'],
        'city': !exists(json, 'city') ? undefined : json['city'],
        'state': !exists(json, 'state') ? undefined : json['state'],
        'provider_type': !exists(json, 'provider_type') ? undefined : json['provider_type'],
    };
}

export function RecipientResolutionCandidateToJSON(value?: RecipientResolutionCandidate | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'provider_id': value.provider_id,
        'facility_id': value.facility_id,
        'name': value.name,
        'city': value.city,
        'state': value.state,
        'provider_type': value.provider_type,
    };
}

